import React from 'react';

export class DataInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {
        const files = e.target.files;
        if (files && files[0]) this.props.handleFile(files[0]);
    }
    render() {
        return (
            <form className="form-inline">
                <div className="form-group">
                    <input
                        type="file"
                        class="hidden"
                        placeholder='Choose file to import'
                        title='Choose file to import'
                        className="form-control"
                        id="file"
                        name='Choose file to import'
                        accept={['xlsx', 'xls']}
                        onChange={this.handleChange}
                    />
                </div>
            </form>
        );
    }
}